import React, { ReactNode } from 'react';
import { styled } from '@linaria/react';
import { LovHit } from 'modules/search/slice';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { Text } from '@daedalus/atlas/Text';
import { TranslatedLOVItem } from '@findhotel/sapi';
import { FacilityIcon, IconLoader } from './FacilityIcon';
interface Props {
  facilities: LovHit[] | TranslatedLOVItem[];
}
const FacilitiesList = /*#__PURE__*/styled('ul')({
  name: "FacilitiesList",
  class: "f1u8u073",
  propsAsIs: false
});
const Item = /*#__PURE__*/styled('li')({
  name: "Item",
  class: "i1g9pz03",
  propsAsIs: false
});
const IconContainer = /*#__PURE__*/styled('li')({
  name: "IconContainer",
  class: "ious7zl",
  propsAsIs: false
});
const FacilitiesGridLayout: React.FC<{
  children: ReactNode[];
}> = ({
  children
}) => {
  const childrenArray = React.Children.toArray(children);
  return <FacilitiesList>{childrenArray}</FacilitiesList>;
};
export const FacilitiesGridLoader = ({
  items = 6,
  variant = 'primary'
}: {
  items?: number;
  variant?: 'primary' | 'secondary';
}) => {
  return <FacilitiesGridLayout>
      {new Array(items).fill('').map((_, index) => <Item key={index}>
          {variant === 'secondary' ? <SkeletonLoader width={24} height={24} marginTop={0} /> : <IconLoader />}
          <SkeletonLoader width={80} height={variant === 'secondary' ? 24 : 14} marginTop={0} />
        </Item>)}
    </FacilitiesGridLayout>;
};
export const FacilitiesGrid: React.FC<Props> = ({
  facilities
}) => <>
    <FacilitiesGridLayout>
      {facilities?.map(facility => <Item key={facility.id}>
          <IconContainer>
            <FacilityIcon facility={facility} />
          </IconContainer>
          <Text variant="bodyM">{facility.value}</Text>
        </Item>)}
    </FacilitiesGridLayout>
  </>;

require("./FacilitiesGrid.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FacilitiesGrid.tsx");